module.exports = __webpack_public_path__ + "static/img/csss_eng_1.9de803e4.jpg";